module.exports = {
      id: "share-mail-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#share-mail",
      toString: function () {
        return this.url;
      }
    }